// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__POiPt","tip":"styles_tip__w0eIE"};